const vi = {
  nav: {
    home: "Trang ch\u1ee7",
    browse: "Kh\u00e1m ph\u00e1 \u0110\u00e1m c\u01b0\u1edbi",
    browseWeddings: "Kh\u00e1m ph\u00e1 \u0110\u00e1m c\u01b0\u1edbi",
    dashboard: "B\u1ea3ng \u0111i\u1ec1u khi\u1ec3n",
    messages: "Tin nh\u1eafn",
    profile: "H\u1ed3 s\u01a1",
    login: "\u0110\u0103ng nh\u1eadp",
    register: "\u0110\u0103ng k\u00fd",
    logout: "\u0110\u0103ng xu\u1ea5t",
    admin: "Qu\u1ea3n tr\u1ecb",
  },
  landing: {
    hero: {
      badge: "N\u1ec1n t\u1ea3ng Tr\u1ea3i nghi\u1ec7m \u0110\u00e1m c\u01b0\u1edbi #1",
      title: "Tr\u1ea3i nghi\u1ec7m \u0110\u00e1m c\u01b0\u1edbi Kh\u00f3 qu\u00ean Kh\u1eafp Th\u1ebf gi\u1edbi",
      subtitle: "WEDVAYA k\u1ebft n\u1ed1i c\u00e1c c\u1eb7p \u0111\u00f4i v\u1edbi nh\u1eefng du kh\u00e1ch t\u00ecm ki\u1ebfm tr\u1ea3i nghi\u1ec7m v\u0103n h\u00f3a \u0111\u00edch th\u1ef1c. Tr\u1edf th\u00e0nh m\u1ed9t ph\u1ea7n c\u1ee7a kho\u1ea3nh kh\u1eafc \u0111\u1eb7c bi\u1ec7t \u2013 v\u1edbi t\u01b0 c\u00e1ch ch\u1ee7 nh\u00e0 ho\u1eb7c kh\u00e1ch.",
      cta_host: "B\u1eaft \u0111\u1ea7u l\u00e0m Ch\u1ee7 nh\u00e0",
      cta_guest: "Kh\u00e1m ph\u00e1 \u0110\u00e1m c\u01b0\u1edbi",
    },
    trust: {
      freeRegistration: "\u0110\u0103ng k\u00fd Mi\u1ec5n ph\u00ed",
      securePayment: "Thanh to\u00e1n An to\u00e0n",
      gdprCompliant: "Tu\u00e2n th\u1ee7 GDPR",
    },
    stats: {
      weddings: "\u0110\u00e1m c\u01b0\u1edbi",
      worldwide: "to\u00e0n c\u1ea7u",
      guests: "Kh\u00e1ch",
      matched: "\u0111\u00e3 k\u1ebft n\u1ed1i",
      countries: "Qu\u1ed1c gia",
      represented: "\u0111\u1ea1i di\u1ec7n",
      rating: "\u0110\u00e1nh gi\u00e1",
      average: "trung b\u00ecnh",
    },
    features: {
      title: "T\u1ea1i sao ch\u1ecdn WEDVAYA?",
      subtitle: "Ch\u00fang t\u00f4i gi\u00fap vi\u1ec7c chia s\u1ebb tr\u1ea3i nghi\u1ec7m \u0111\u00e1m c\u01b0\u1edbi kh\u00f3 qu\u00ean tr\u1edf n\u00ean d\u1ec5 d\u00e0ng v\u00e0 an to\u00e0n.",
      secure: {
        title: "Thanh to\u00e1n An to\u00e0n",
        desc: "T\u1ea5t c\u1ea3 giao d\u1ecbch \u0111\u01b0\u1ee3c b\u1ea3o v\u1ec7 b\u1edfi Stripe. Ti\u1ec1n c\u1ee7a b\u1ea1n an to\u00e0n cho \u0111\u1ebfn khi s\u1ef1 ki\u1ec7n di\u1ec5n ra.",
      },
      verified: {
        title: "H\u1ed3 s\u01a1 \u0110\u00e3 x\u00e1c minh",
        desc: "X\u00e1c minh danh t\u00ednh t\u00f9y ch\u1ecdn \u0111\u1ec3 t\u0103ng \u0111\u1ed9 tin c\u1eady gi\u1eefa ch\u1ee7 nh\u00e0 v\u00e0 kh\u00e1ch.",
      },
      global: {
        title: "S\u1ef1 ki\u1ec7n To\u00e0n c\u1ea7u",
        desc: "T\u1eeb \u0111\u00e1m c\u01b0\u1edbi l\u00e3ng m\u1ea1n \u1edf Tuscany \u0111\u1ebfn l\u1ec5 c\u01b0\u1edbi truy\u1ec1n th\u1ed1ng \u1edf \u1ea4n \u0110\u1ed9.",
      },
      contact: {
        title: "Li\u00ean h\u1ec7 Tr\u1ef1c ti\u1ebfp",
        desc: "Sau khi \u0111\u1eb7t ch\u1ed7, b\u1ea1n c\u00f3 th\u1ec3 li\u00ean l\u1ea1c tr\u1ef1c ti\u1ebfp v\u1edbi ch\u1ee7 nh\u00e0.",
      },
      gdpr: {
        title: "Tu\u00e2n th\u1ee7 GDPR",
        desc: "D\u1eef li\u1ec7u c\u1ee7a b\u1ea1n \u0111\u01b0\u1ee3c b\u1ea3o m\u1eadt. Ch\u00fang t\u00f4i tu\u00e2n th\u1ee7 nghi\u00eam ng\u1eb7t c\u00e1c quy \u0111\u1ecbnh b\u1ea3o v\u1ec7 d\u1eef li\u1ec7u ch\u00e2u \u00c2u.",
      },
      instant: {
        title: "\u0110\u1eb7t ch\u1ed7 T\u1ee9c th\u00ec",
        desc: "Quy tr\u00ecnh \u0111\u0103ng k\u00fd nhanh ch\u00f3ng. B\u1ea1n s\u1ebd nh\u1eadn \u0111\u01b0\u1ee3c ph\u1ea3n h\u1ed3i trong 48 gi\u1edd.",
      },
    },
    howItWorks: {
      title: "C\u00e1ch ho\u1ea1t \u0111\u1ed9ng",
      subtitle: "Ch\u1ec9 v\u00e0i b\u01b0\u1edbc \u0111\u1ec3 c\u00f3 tr\u1ea3i nghi\u1ec7m kh\u00f3 qu\u00ean",
      step1: {
        title: "T\u00ecm \u0110\u00e1m c\u01b0\u1edbi",
        desc: "Duy\u1ec7t qua c\u00e1c \u0111\u00e1m c\u01b0\u1edbi \u0111\u1ed9c \u0111\u00e1o tr\u00ean kh\u1eafp th\u1ebf gi\u1edbi.",
      },
      step2: {
        title: "G\u1eedi \u0110\u01a1n \u0111\u0103ng k\u00fd",
        desc: "Gi\u1edbi thi\u1ec7u b\u1ea3n th\u00e2n v\u1edbi c\u1eb7p \u0111\u00f4i v\u00e0 cho h\u1ecd bi\u1ebft l\u00fd do b\u1ea1n mu\u1ed1n tham d\u1ef1.",
      },
      step3: {
        title: "X\u00e1c nh\u1eadn & Thanh to\u00e1n",
        desc: "Sau khi \u0111\u01b0\u1ee3c ch\u1ea5p thu\u1eadn, thanh to\u00e1n an to\u00e0n tr\u1ef1c tuy\u1ebfn. Ch\u1ec9 khi \u0111\u00f3 ch\u1ed7 c\u1ee7a b\u1ea1n m\u1edbi \u0111\u01b0\u1ee3c gi\u1eef.",
      },
      step4: {
        title: "\u0102n m\u1eebng",
        desc: "Tr\u1ea3i nghi\u1ec7m \u0111\u00e1m c\u01b0\u1edbi \u0111\u00edch th\u1ef1c v\u00e0 t\u1ea1o ra k\u1ef7 ni\u1ec7m su\u1ed1t \u0111\u1eddi.",
      },
    },
    howItWorksHost: {
      step1: {
        title: "\u0110\u0103ng \u0110\u00e1m c\u01b0\u1edbi c\u1ee7a b\u1ea1n",
        desc: "T\u1ea1o h\u1ed3 s\u01a1 cho \u0111\u00e1m c\u01b0\u1edbi v\u1edbi t\u1ea5t c\u1ea3 chi ti\u1ebft quan tr\u1ecdng.",
      },
      step2: {
        title: "Xem x\u00e9t \u0110\u0103ng k\u00fd",
        desc: "Xem h\u1ed3 s\u01a1 c\u1ee7a c\u00e1c kh\u00e1ch quan t\u00e2m.",
      },
      step3: {
        title: "Nh\u1eadn Thanh to\u00e1n",
        desc: "Sau s\u1ef1 ki\u1ec7n, b\u1ea1n t\u1ef1 \u0111\u1ed9ng nh\u1eadn 85% doanh thu.",
      },
      step4: {
        title: "C\u00f9ng \u0102n m\u1eebng",
        desc: "Chia s\u1ebb ng\u00e0y \u0111\u1eb7c bi\u1ec7t c\u1ee7a b\u1ea1n v\u1edbi m\u1ecdi ng\u01b0\u1eddi t\u1eeb kh\u1eafp n\u01a1i tr\u00ean th\u1ebf gi\u1edbi.",
      },
    },
    tabs: {
      forGuests: "D\u00e0nh cho Kh\u00e1ch",
      forHosts: "D\u00e0nh cho Ch\u1ee7 nh\u00e0",
    },
    testimonials: {
      title: "C\u1ed9ng \u0111\u1ed3ng n\u00f3i g\u00ec",
      subtitle: "Tr\u1ea3i nghi\u1ec7m th\u1ef1c t\u1ebf t\u1eeb ng\u01b0\u1eddi th\u1ef1c",
    },
    featured: {
      title: "\u0110\u00e1m c\u01b0\u1edbi N\u1ed5i b\u1eadt",
      subtitle: "Kh\u00e1m ph\u00e1 c\u00e1c l\u1ec5 k\u1ef7 ni\u1ec7m \u0111\u1ed9c \u0111\u00e1o tr\u00ean to\u00e0n th\u1ebf gi\u1edbi",
      viewAll: "Xem T\u1ea5t c\u1ea3",
      perPerson: "m\u1ed7i ng\u01b0\u1eddi",
    },
    cta: {
      title: "S\u1eb5n s\u00e0ng cho Tr\u1ea3i nghi\u1ec7m Kh\u00f3 qu\u00ean?",
      subtitle: "Tham gia c\u1ed9ng \u0111\u1ed3ng WEDVAYA",
      description: "D\u00f9 b\u1ea1n mu\u1ed1n chia s\u1ebb \u0111\u00e1m c\u01b0\u1edbi v\u1edbi th\u1ebf gi\u1edbi hay t\u00ecm ki\u1ebfm tr\u1ea3i nghi\u1ec7m du l\u1ecbch \u0111\u1ed9c \u0111\u00e1o \u2013 WEDVAYA bi\u1ebfn \u0111i\u1ec1u \u0111\u00f3 th\u00e0nh hi\u1ec7n th\u1ef1c.",
      button: "\u0110\u0103ng k\u00fd Mi\u1ec5n ph\u00ed",
      becomeHost: "Tr\u1edf th\u00e0nh Ch\u1ee7 nh\u00e0 Ngay",
      learnMore: "T\u00ecm hi\u1ec3u Th\u00eam",
    },
    press: {
      title: "\u0110\u01b0\u1ee3c \u0111\u01b0a tin b\u1edfi",
    },
  },
  auth: {
    login: {
      title: "Ch\u00e0o m\u1eebng Tr\u1edf l\u1ea1i",
      email: "Email",
      password: "M\u1eadt kh\u1ea9u",
      button: "\u0110\u0103ng nh\u1eadp",
      noAccount: "Ch\u01b0a c\u00f3 t\u00e0i kho\u1ea3n?",
      register: "\u0110\u0103ng k\u00fd ngay",
      forgotPassword: "Qu\u00ean m\u1eadt kh\u1ea9u?",
    },
    register: {
      title: "T\u1ea1o T\u00e0i kho\u1ea3n",
      name: "H\u1ecd v\u00e0 t\u00ean",
      email: "Email",
      password: "M\u1eadt kh\u1ea9u",
      role: "T\u00f4i mu\u1ed1n...",
      roleHost: "T\u1ed5 ch\u1ee9c \u0111\u00e1m c\u01b0\u1edbi",
      roleGuest: "Tham d\u1ef1 \u0111\u00e1m c\u01b0\u1edbi",
      terms: "T\u00f4i ch\u1ea5p nh\u1eadn \u0110i\u1ec1u kho\u1ea3n v\u00e0 Ch\u00ednh s\u00e1ch B\u1ea3o m\u1eadt",
      button: "\u0110\u0103ng k\u00fd",
      hasAccount: "\u0110\u00e3 c\u00f3 t\u00e0i kho\u1ea3n?",
      login: "\u0110\u0103ng nh\u1eadp ngay",
    },
    forgotPassword: {
      title: "Qu\u00ean M\u1eadt kh\u1ea9u?",
      description: "Nh\u1eadp email c\u1ee7a b\u1ea1n v\u00e0 ch\u00fang t\u00f4i s\u1ebd g\u1eedi li\u00ean k\u1ebft \u0111\u1eb7t l\u1ea1i",
      submit: "G\u1eedi Li\u00ean k\u1ebft",
      sent: "Ki\u1ec3m tra Email c\u1ee7a b\u1ea1n",
      sentDescription: "N\u1ebfu c\u00f3 t\u00e0i kho\u1ea3n v\u1edbi email n\u00e0y, b\u1ea1n s\u1ebd nh\u1eadn \u0111\u01b0\u1ee3c li\u00ean k\u1ebft \u0111\u1eb7t l\u1ea1i m\u1eadt kh\u1ea9u.",
      backToLogin: "Quay l\u1ea1i \u0110\u0103ng nh\u1eadp",
    },
    resetPassword: {
      title: "\u0110\u1eb7t l\u1ea1i M\u1eadt kh\u1ea9u",
      description: "Nh\u1eadp m\u1eadt kh\u1ea9u m\u1edbi c\u1ee7a b\u1ea1n",
      newPassword: "M\u1eadt kh\u1ea9u M\u1edbi",
      confirmPassword: "X\u00e1c nh\u1eadn M\u1eadt kh\u1ea9u",
      submit: "\u0110\u1eb7t l\u1ea1i M\u1eadt kh\u1ea9u",
      success: "M\u1eadt kh\u1ea9u \u0111\u00e3 \u0111\u01b0\u1ee3c \u0111\u1eb7t l\u1ea1i!",
      successDesc: "M\u1eadt kh\u1ea9u c\u1ee7a b\u1ea1n \u0111\u00e3 \u0111\u01b0\u1ee3c \u0111\u1eb7t l\u1ea1i th\u00e0nh c\u00f4ng. B\u1ea1n c\u00f3 th\u1ec3 \u0111\u0103ng nh\u1eadp ngay.",
      goToLogin: "\u0110i \u0111\u1ebfn \u0110\u0103ng nh\u1eadp",
      mismatch: "M\u1eadt kh\u1ea9u kh\u00f4ng kh\u1edbp",
      tooShort: "M\u1eadt kh\u1ea9u ph\u1ea3i c\u00f3 \u00edt nh\u1ea5t 6 k\u00fd t\u1ef1",
    },
    verification: {
      verifying: "\u0110ang x\u00e1c minh email c\u1ee7a b\u1ea1n...",
      pleaseWait: "Vui l\u00f2ng \u0111\u1ee3i",
      successTitle: "Email \u0111\u00e3 x\u00e1c minh!",
      success: "Email c\u1ee7a b\u1ea1n \u0111\u00e3 \u0111\u01b0\u1ee3c x\u00e1c minh th\u00e0nh c\u00f4ng!",
      errorTitle: "X\u00e1c minh Th\u1ea5t b\u1ea1i",
      noToken: "Kh\u00f4ng c\u00f3 m\u00e3 x\u00e1c minh",
      goToLogin: "\u0110i \u0111\u1ebfn \u0110\u0103ng nh\u1eadp",
      tryAgain: "\u0110\u0103ng k\u00fd L\u1ea1i",
    },
  },
  dashboard: {
    host: {
      title: "B\u1ea3ng \u0111i\u1ec1u khi\u1ec3n Ch\u1ee7 nh\u00e0",
      myWeddings: "\u0110\u00e1m c\u01b0\u1edbi c\u1ee7a t\u00f4i",
      applications: "\u0110\u01a1n \u0111\u0103ng k\u00fd",
      earnings: "Thu nh\u1eadp",
      messages: "Tin nh\u1eafn",
      createWedding: "T\u1ea1o \u0110\u00e1m c\u01b0\u1edbi",
      noWeddings: "Ch\u01b0a t\u1ea1o \u0111\u00e1m c\u01b0\u1edbi n\u00e0o",
    },
    guest: {
      title: "B\u1ea3ng \u0111i\u1ec1u khi\u1ec3n Kh\u00e1ch",
      myApplications: "\u0110\u01a1n \u0111\u0103ng k\u00fd c\u1ee7a t\u00f4i",
      browseWeddings: "Kh\u00e1m ph\u00e1 \u0110\u00e1m c\u01b0\u1edbi",
      messages: "Tin nh\u1eafn",
      profile: "H\u1ed3 s\u01a1 c\u1ee7a t\u00f4i",
    },
  },
  wedding: {
    search: {
      title: "T\u00ecm \u0110\u00e1m c\u01b0\u1edbi",
      location: "\u0110\u1ecba \u0111i\u1ec3m",
      date: "Ng\u00e0y",
      price: "Gi\u00e1",
      search: "T\u00ecm ki\u1ebfm",
      reset: "\u0110\u1eb7t l\u1ea1i",
      noResults: "Kh\u00f4ng t\u00ecm th\u1ea5y \u0111\u00e1m c\u01b0\u1edbi",
    },
    card: {
      slots: "ch\u1ed7 tr\u1ed1ng",
      perGuest: "m\u1ed7i kh\u00e1ch",
      apply: "\u0110\u0103ng k\u00fd",
      viewDetails: "Xem Chi ti\u1ebft",
    },
    detail: {
      about: "V\u1ec1 \u0110\u00e1m c\u01b0\u1edbi n\u00e0y",
      host: "Ch\u1ee7 nh\u00e0",
      location: "\u0110\u1ecba \u0111i\u1ec3m",
      date: "Ng\u00e0y",
      dresscode: "Quy \u0111\u1ecbnh Trang ph\u1ee5c",
      price: "Gi\u00e1 m\u1ed7i Kh\u00e1ch",
      slots: "Ch\u1ed7 tr\u1ed1ng",
      apply: "\u0110\u0103ng k\u00fd Ngay",
      alreadyApplied: "\u0110\u00e3 \u0110\u0103ng k\u00fd",
    },
    create: {
      title: "T\u1ea1o \u0110\u00e1m c\u01b0\u1edbi M\u1edbi",
      titleField: "Ti\u00eau \u0111\u1ec1",
      description: "M\u00f4 t\u1ea3",
      location: "\u0110\u1ecba \u0111i\u1ec3m",
      country: "Qu\u1ed1c gia",
      date: "Ng\u00e0y",
      dresscode: "Quy \u0111\u1ecbnh Trang ph\u1ee5c",
      price: "Gi\u00e1 m\u1ed7i Kh\u00e1ch",
      slots: "S\u1ed1 l\u01b0\u1ee3ng Kh\u00e1ch",
      currency: "Ti\u1ec1n t\u1ec7",
      submit: "T\u1ea1o \u0110\u00e1m c\u01b0\u1edbi",
    },
  },
  application: {
    status: {
      pending: "\u0110ang ch\u1edd",
      approved: "\u0110\u00e3 duy\u1ec7t",
      rejected: "B\u1ecb t\u1eeb ch\u1ed1i",
    },
    payment: {
      pending: "Ch\u1edd Thanh to\u00e1n",
      paid: "\u0110\u00e3 Thanh to\u00e1n",
      pay: "Thanh to\u00e1n Ngay",
    },
    approve: "Duy\u1ec7t",
    reject: "T\u1eeb ch\u1ed1i",
  },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

  messages: {
    title: "Tin nh\u1eafn",
    noMessages: "Kh\u00f4ng c\u00f3 tin nh\u1eafn",
    placeholder: "Vi\u1ebft tin nh\u1eafn...",
    send: "G\u1eedi",
  },
  admin: {
    title: "B\u1ea3ng \u0111i\u1ec1u khi\u1ec3n Qu\u1ea3n tr\u1ecb",
    stats: {
      users: "Ng\u01b0\u1eddi d\u00f9ng",
      hosts: "Ch\u1ee7 nh\u00e0",
      guests: "Kh\u00e1ch",
      weddings: "\u0110\u00e1m c\u01b0\u1edbi",
      activeWeddings: "\u0110\u00e1m c\u01b0\u1edbi \u0110ang ho\u1ea1t \u0111\u1ed9ng",
      applications: "\u0110\u01a1n \u0111\u0103ng k\u00fd",
      revenue: "T\u1ed5ng Doanh thu",
      platformEarnings: "Thu nh\u1eadp N\u1ec1n t\u1ea3ng",
    },
    tabs: {
      overview: "T\u1ed5ng quan",
      users: "Ng\u01b0\u1eddi d\u00f9ng",
      weddings: "\u0110\u00e1m c\u01b0\u1edbi",
      transactions: "Giao d\u1ecbch",
    },
    actions: {
      ban: "C\u1ea5m",
      unban: "B\u1ecf c\u1ea5m",
      feature: "N\u1ed5i b\u1eadt",
      unfeature: "B\u1ecf N\u1ed5i b\u1eadt",
    },
  },
  common: {
    loading: "\u0110ang t\u1ea3i...",
    error: "\u0110\u00e3 x\u1ea3y ra l\u1ed7i",
    success: "Th\u00e0nh c\u00f4ng",
    save: "L\u01b0u",
    cancel: "H\u1ee7y",
    delete: "X\u00f3a",
    edit: "S\u1eeda",
    back: "Quay l\u1ea1i",
    next: "Ti\u1ebfp theo",
    language: "Ng\u00f4n ng\u1eef",
    currency: "Ti\u1ec1n t\u1ec7",
  },
  footer: {
    about: "Gi\u1edbi thi\u1ec7u",
    privacy: "Quy\u1ec1n ri\u00eang t\u01b0",
    terms: "\u0110i\u1ec1u kho\u1ea3n",
    contact: "Li\u00ean h\u1ec7",
    description: "N\u1ec1n t\u1ea3ng to\u00e0n c\u1ea7u cho tr\u1ea3i nghi\u1ec7m \u0111\u00e1m c\u01b0\u1edbi kh\u00f3 qu\u00ean.",
    copyright: "\u00a9 2024 WEDVAYA. B\u1ea3o l\u01b0u m\u1ecdi quy\u1ec1n.",
  },
  notifications: {
    title: "Th\u00f4ng b\u00e1o",
    empty: "Ch\u01b0a c\u00f3 th\u00f4ng b\u00e1o",
    markAllRead: "\u0110\u00e1nh d\u1ea5u t\u1ea5t c\u1ea3 \u0111\u00e3 \u0111\u1ecdc",
  },
  chat: {
    conversations: "Cu\u1ed9c tr\u00f2 chuy\u1ec7n",
    search: "T\u00ecm cu\u1ed9c tr\u00f2 chuy\u1ec7n...",
    noConversations: "Ch\u01b0a c\u00f3 cu\u1ed9c tr\u00f2 chuy\u1ec7n",
    selectConversation: "Ch\u1ecdn cu\u1ed9c tr\u00f2 chuy\u1ec7n",
    selectConversationDesc: "Ch\u1ecdn m\u1ed9t cu\u1ed9c tr\u00f2 chuy\u1ec7n t\u1eeb danh s\u00e1ch \u0111\u1ec3 b\u1eaft \u0111\u1ea7u nh\u1eafn tin",
    online: "Tr\u1ef1c tuy\u1ebfn",
    offline: "Ngo\u1ea1i tuy\u1ebfn",
    connecting: "\u0110ang k\u1ebft n\u1ed1i...",
    noMessages: "Ch\u01b0a c\u00f3 tin nh\u1eafn",
    startConversation: "B\u1eaft \u0111\u1ea7u tr\u00f2 chuy\u1ec7n!",
    placeholder: "Nh\u1eadp tin nh\u1eafn...",
    you: "B\u1ea1n",
  },
  cookies: {
    title: "Ch\u00fang t\u00f4i s\u1eed d\u1ee5ng cookie",
    description: "Ch\u00fang t\u00f4i s\u1eed d\u1ee5ng cookie \u0111\u1ec3 c\u1ea3i thi\u1ec7n tr\u1ea3i nghi\u1ec7m c\u1ee7a b\u1ea1n, ph\u00e2n t\u00edch l\u01b0u l\u01b0\u1ee3ng v\u00e0 cho m\u1ee5c \u0111\u00edch ti\u1ebfp th\u1ecb.",
    acceptAll: "Ch\u1ea5p nh\u1eadn T\u1ea5t c\u1ea3",
    rejectAll: "T\u1eeb ch\u1ed1i T\u1ea5t c\u1ea3",
    customize: "T\u00f9y ch\u1ec9nh",
    settingsTitle: "C\u00e0i \u0111\u1eb7t Cookie",
    functional: "Cookie Ch\u1ee9c n\u0103ng",
    functionalDesc: "C\u1ea7n thi\u1ebft \u0111\u1ec3 trang web ho\u1ea1t \u0111\u1ed9ng \u0111\u00fang.",
    analytics: "Cookie Ph\u00e2n t\u00edch",
    analyticsDesc: "Gi\u00fap ch\u00fang t\u00f4i hi\u1ec3u c\u00e1ch kh\u00e1ch truy c\u1eadp t\u01b0\u01a1ng t\u00e1c v\u1edbi trang web.",
    marketing: "Cookie Ti\u1ebfp th\u1ecb",
    marketingDesc: "\u0110\u01b0\u1ee3c s\u1eed d\u1ee5ng \u0111\u1ec3 hi\u1ec3n th\u1ecb qu\u1ea3ng c\u00e1o c\u00e1 nh\u00e2n h\u00f3a.",
    saveSettings: "L\u01b0u C\u00e0i \u0111\u1eb7t",
  },
};

export default vi;
